// import {
//   postRequest, getRequest
// } from './axiosPkg'
// export function handleLogin () {
//   postRequest(`/login`, {})
// }
import { httpClient } from './'
export const _password_update = ({
  user_name,
  new_password,
  old_password,
  api_key
}) => {
  return httpClient
    .post(
      `password_update/`,
      {
        user_name,
        new_password,
        old_password
      },
      {
        headers: {
          'api-key': api_key
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`))
      }
    })
}
export const _pwd_check_update = api_key => {
  return httpClient
    .get(`password/check_update`, {
      headers: {
        'api-key': api_key
      }
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`))
      }
    })
}
export const _login = (user_name, password) => {
  return httpClient.post(`login/`,
    {
      user_name, password
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.data}`))
    }
  })
}
